import React, {useEffect, useState} from 'react'
import { config } from '../server'
const address = config.url.API_URL

const Requests = (props) => {
    const space = props.match.params.spaceName
    const [spaceInfo, setSpaceInfo] = useState({})
    const [requests, setRequests] = useState([])

    useEffect(() => {
        let mounted = true
        fetch(address + `/api/space/${space}`).then(res => res.json()).then(data => {
           // console.log(data.space[0])
            if(mounted) {
                setSpaceInfo(data.space[0])
            }
        })





        fetch(address + `/api/${space}/spaceRequests`).then(res => res.json()).then(data => {
            // console.log(data.space[0])
             if(mounted) {
                 setRequests(data.allRequests)
             }
            // console.log(data)
         })




        return () => {
            mounted = false
        }
    }, [space])


    const confirmation = async (decision, requestingUser) => {
        const requestOptions = {
            method: 'POST',
            headers: { 
              'content-type': 'application/json' },
            body: JSON.stringify({ owner: spaceInfo.owner, space: space, 
                requestingUser: requestingUser, decision: decision })
        };
        //console.log(requestingUser)
         await fetch(address + '/confirmation', requestOptions)
        //const data = await res.json()
        const refetch = await fetch(address + `/api/${space}/spaceRequests`)
        const dataRefetch = await refetch.json()
        setRequests(dataRefetch.allRequests)
        //console.log(data)
    }

    return (
        <>
        <div className="hero is-primary">
			<div className="hero-body">
				<div className="container">
					<div className="level-left">
						<h1 className="title">
                            {space}
						</h1>
					</div>
					<div className="level-left">
                    <h2 className="subtitle">
                            {spaceInfo.description}
						</h2>
					</div>
                    <div className="level-left">
                        <button className="button is-danger">Delete</button>
                    </div>
				</div>
			</div>
		</div>       
        <div className="level">
            <div className="level-item">
                Requests to join your space
            </div>
        </div>
        <div className="level-item">
    <div className="column is-6">
      {requests.map((request,i) => (
        <ul key={i}>
        <li key={i}>
          <div key={i}>
          <div key={i} className="card">
            <header key={i+1} className="card-header">
              <p className="card-header-title">
                {request.requestingUser}
              </p>
              <div className="level-right">
                  <button className="button is-link" onClick={() => confirmation('accept', request.requestingUser)}>
                      Accept
                  </button>
                  <div style={{paddingLeft: '2%'}}>
                  <button className="button is-danger" onClick={() => confirmation('decline', request.requestingUser)}>
                      Decline
                  </button>
                  </div>
              </div>
        </header>
      </div>
          </div>
        </li>
      </ul>
      ))}
    </div>
    </div>
        
         </>
    )
}

export default Requests